import React from "react";

import { STORE_FILTERS } from "../../utils/stateTypes";

const data = [
  {
    id: "sleeping-guide",
    image: "/images/store/sleeping-plan.webp",
    gallery: [
      "/images/store/sleeping-gal-1.webp",
      "/images/store/sleeping-gal-2.webp",
    ],
    name: "Sleeping Guide",
    price: 420,
    metaDescription: "Evidence-based nutrition guidance for better sleep, with a supporting meal plan from a registered dietitian.",
    description: (
      <React.Fragment>
        <h3>Who is this guide for?</h3>
        <p>
          Anyone looking to receive evidence-based information on improving their sleep through nutritional intervention.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to improve your sleep quality through diet.</li>
          <li>A simple menu with meal ideas that will support your body to improve your sleep health and improve your overall health.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "reflux-guide",
    image: "/images/store/reflux-plan.webp",
    gallery: [
      "/images/store/reflux-gal-1.webp",
      "/images/store/reflux-gal-2.webp",
    ],
    name: "Reflux Guide",
    price: 420,
    metaDescription: "A dietitian-designed guide to managing reflux and heartburn through diet, with a supporting meal plan.",
    description: (
      <React.Fragment>
        <h3>What is reflux?</h3>
        <p>
          Reflux occurs when stomach acid flows back into the oesophagus, the tube that connects the throat to the stomach. 
          This backflow can cause irritation and discomfort, commonly known as heartburn. Symptoms include a burning sensation 
          in the chest, regurgitation of sour-tasting liquid or food, difficulty swallowing, or a sensation of a lump in the throat.
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          Anyone looking to receive evidence-based information on how to alleviate and improve symptoms from reflux.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to alleviate reflux.</li>
          <li>A simple menu with meal ideas that will support your body to improve your reflux.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "vegan-guide",
    image: "/images/store/vegan-plan.webp",
    gallery: [
      "/images/store/vegan-gal-1.webp",
      "/images/store/vegan-gal-2.webp",
    ],
    name: "Vegan Guide",
    price: 420,
    metaDescription: "Evidence-based guidance for eating a balanced vegan diet, with a supporting meal plan from a registered dietitian.",
    description: (
      <React.Fragment>
        <h3>What is a vegan diet?</h3>
        <p>
          A vegan diet is a way of eating that excludes all animal products and focuses entirely on plant-based foods. 
          This means avoiding meat, poultry, fish, dairy, eggs, and any other animal-derived ingredients.
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          Anyone looking to receive evidence-based information on how to eat a vegan diet while achieving optimal nutritional health.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to follow a balanced vegan diet.</li>
          <li>A simple menu with meal ideas that will support your body to achieve optimal health through a vegan diet.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "iron-guide",
    image: "/images/store/iron-plan1.webp",
    gallery: [
      "/images/store/iron-gal-1.webp",
      "/images/store/iron-gal-2.webp",
    ],
    name: "Iron Deficiency Guide",
    price: 420,
    metaDescription: "A dietitian-designed guide to improving iron levels through diet, with a supporting meal plan.",
    description: (
      <React.Fragment>
        <h3>What is an iron deficiency?</h3>
        <p>
          Iron deficiency occurs when the body does not have enough iron to produce adequate amounts of haemoglobin, 
          a protein in red blood cells that carries oxygen throughout the body. It is one of the most common nutritional 
          deficiencies worldwide and can lead to iron deficiency anaemia if left untreated. Symptoms include fatigue or weakness, 
          pale skin, shortness of breath or dizziness.
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          Anyone looking to receive evidence-based information on improving their iron levels.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to increase your iron levels.</li>
          <li>A simple menu with meal ideas that will support your body to improve your iron and relieve the side effects of low iron.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "constipation-guide",
    image: "/images/store/constipation-plan.webp",
    gallery: [
      "/images/store/constipation-gal-1.webp",
      "/images/store/constipation-gal-2.webp",
    ],
    name: "Constipation Guide",
    price: 420,
    metaDescription: "Evidence-based dietary guidance for managing constipation, with a supporting meal plan from a registered dietitian.",
    description: (
      <React.Fragment>
        <h3>What is constipation?</h3>
        <p>
          Constipation is a condition in which passing stools becomes difficult or bowel movements occur less than 
          three times per week. However, normal bowel movement frequency may vary from person to person. Symptoms include 
          hard or lumpy stools, straining during bowel movements and/or a feeling of incomplete evacuation.
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          Anyone looking to receive evidence-based information on how to manage their constipation better.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to improve your constipation.</li>
          <li>A simple menu with meal ideas that will support your body to improve your gut health and relieve constipation.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "ibs-guide",
    image: "/images/store/ibs-guide.webp",
    gallery: [
      "/images/store/ibs-gal-1.webp",
      "/images/store/ibs-gal-2.webp",
    ],
    name: "IBS Guide",
    price: 420,
    metaDescription: "A low FODMAP guide for managing IBS symptoms, with a supporting meal plan from a registered dietitian.",
    description: (
      <React.Fragment>
        <h3>What is IBS?</h3>
        <p>
          IBS (Irritable Bowel Syndrome) is a common disorder that affects the large
          intestine (colon). Symptoms include gastro-intestinal issues such as diarrhoea
          constipation, reux, heartburn, gas, cramping and bloating.
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          IBS has been shown to affect 1 in 7 people and 15% of the population worldwide.
          This guide shows you how to manage your IBS symptoms through a low FODMAP
          diet.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to practically manage your IBS.</li>
          <li>A simple menu with meal ideas that will support your body to improve your gut health and relieve your IBS symptoms.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "cholesterol-guide",
    image: "/images/store/cholesterol-guide.webp",
    gallery: [
      "/images/store/cholesterol-gal-1.webp",
      "/images/store/cholesterol-gal-2.webp",
    ],
    name: "Cholesterol Guide",
    price: 420,
    metaDescription: "A dietitian-designed guide to lowering cholesterol through diet, with a supporting meal plan.",
    description: (
      <React.Fragment>
        <h3>What is cholesterol?</h3>
        <p>
          High cholesterol means there’s too much cholesterol in your blood. Cholesterol is a
          fatty substance your body needs to build cells and make certain hormones, but too
          much of it can cause health problems. Excess cholesterol can stick to the walls of
          your blood vessels and form plaque, which narrows the arteries, thus slowing down
          blood ow. High cholesterol increases the risk of heart attacks and strokes.
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          Anyone looking to receive evidence-based information on how to better manage their
          cholesterol levels through diet.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to decrease your cholesterol.</li>
          <li>A simple menu with meal ideas that will support your body to improve your cholesterol levels and improve your heart health.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "pcos-guide",
    image: "/images/store/pcos-guide.webp",
    gallery: [
      "/images/store/pcos-gal-1.webp",
      "/images/store/pcos-gal-2.webp",
    ],
    name: "PCOS Guide",
    price: 420,
    metaDescription: "Evidence-based dietary guidance for managing PCOS long-term, with a supporting meal plan from a registered dietitian.",
    description: (
      <React.Fragment>
        <h3>What is PCOS?</h3>
        <p>
          PCOS, or Polycystic Ovary Syndrome, is a condition that affects how a woman’s
          ovaries work. It’s caused by a hormonal imbalance and can lead to a variety of
          symptoms. PCOS, can show in many ways in a female body and can be managed
          long term through dietary intervention.
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          There is a lot of misinformation about PCOS. This guide is for anyone looking to
          receive evidence-based information on how to effectively manage their PCOS
          through dietary and lifestyle long-term management.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to practically manage your PCOS.</li>
          <li>A simple low-calorie menu with meal ideas that will support your body to improve hormone imbalance and better manage your PCOS.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "blood-pressure-guide",
    image: "/images/store/blood-pressure-guide.webp",
    gallery: [
      "/images/store/blood-pressure-gal-1.webp",
      "/images/store/blood-pressure-gal-2.webp",
    ],
    name: "Blood Pressure Guide",
    price: 420,
    metaDescription: "A dietitian-designed guide to managing blood pressure through diet, with a supporting meal plan.",
    description: (
      <React.Fragment>
        <h3>What is high blood pressure?</h3>
        <p>
          High blood pressure, or hypertension, means that the blood pushing through your
          blood vessels is stronger than it should be. Over time, this can strain your heart and
          damage your blood vessels.
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          Anyone looking to receive evidence-based information on how to manage blood
          pressure through dietary intervention.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to practically manage your blood pressure.</li>
          <li>A simple menu with meal ideas that will support your body to lower its blood pressure.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "diarrhoea-guide",
    image: "/images/store/diarrhoea-guide.webp",
    gallery: [
      "/images/store/diarrhoea-gal-1.webp",
      "/images/store/diarrhoea-gal-2.webp",
    ],
    name: "Diarrhoea Guide",
    price: 420,
    metaDescription: "Evidence-based dietary guidance for managing short- and long-term diarrhoea, from a registered dietitian.",
    description: (
      <React.Fragment>
        <h3>What is Diarrhoea?</h3>
        <p>
          Diarrhoea happens when you have frequent, loose, or watery stools. This can make
          you go to the bathroom more often than usual. It can be mild and short-lived, or in
          some cases, more serious and long-lasting, depending on what’s causing it.
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          Anyone looking to receive evidence-based information on how to manage short- or
          long-term diarrhoea.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to practically manage diarrhoea.</li>
          <li>A simple menu with meal ideas that will support your body to reduce symptoms.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "anti-inflammatory-guide",
    image: "/images/store/anti-inflammatory-guide.webp",
    gallery: [
      "/images/store/anti-inflammatory-gal-1.webp",
      "/images/store/anti-inflammatory-gal-2.webp",
    ],
    name: "Anti-Inflammatory Guide",
    price: 420,
    metaDescription: "An anti-inflammatory eating guide for managing chronic inflammation, with a supporting meal plan from a registered dietitian.",
    description: (
      <React.Fragment>
        <h3>What is inflammation?</h3>
        <p>
          Inflammation is the body's natural response to injury, infection, or irritation. As a
          dietitian, I will help you focus on anti-inflammatory foods and dietary patterns to help
          manage chronic inflammation.
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          Anyone looking to receive evidence-based information on how to manage
          inflammation through dietary intervention. An anti-inflammatory diet is benecial for
          people dealing with chronic inflammation or conditions where inflammation plays a
          major role. Chronic inflammation is linked to several health issues, and managing it
          through diet can help improve symptoms and overall well-being. Some individuals
          that may benet from an anti-inflammatory diet include – but is not limited to:
          <ul>
            <li>Those with auto-immune disorders</li>
            <li>Arthritis</li>
            <li>Chronic pain / fatigue</li>
            <li>Skin conditions</li>
            <li>Obesity</li>
          </ul>
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Guidelines on how to practically manage your inflammation.</li>
          <li>A simple menu with meal ideas that will support your body to improve hormone imbalance and better manage your inflammation.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "diabetes-guide",
    image: "/images/store/diabetes-guide.webp",
    gallery: [
      "/images/store/diabetes-gal-1.webp",
      "/images/store/diabetes-gal-2.webp",
    ],
    name: "Diabetes Guide",
    price: 420,
    metaDescription: "Evidence-based nutrition strategies for managing type 2 diabetes and prediabetes, from a registered dietitian.",
    description: (
      <React.Fragment>
        <h3>What is Diabetes?</h3>
        <p>
          Diabetes is a chronic condition that affects how the body processes blood sugar (glucose), leading
          to elevated levels in the bloodstream. It occurs when the body either doesn’t produce enough
          insulin (type 1) or becomes resistant to insulin (type 2).
        </p>
        <h3>Who is this guide for?</h3>
        <p>
          This guide is for individuals with type 2 diabetes or pre-diabetes who want evidence-based nutrition
          strategies to manage their condition. Proper dietary choices can help improve insulin sensitivity, prevent
          blood sugar spikes, and reduce the risk of complications. Those who may benefit include:
          <ul>
            <li>Individuals with type 2 diabetes.</li>
            <li>Those with insulin resistance or prediabetes.</li>
            <li>People looking to maintain stable blood sugar levels and improve overall metabolic health.</li>
          </ul>
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>Practical guidelines to help manage unstable blood sugar through balanced nutrition.</li>
          <li>A simple menu with meal ideas designed to support blood sugar control.</li>
          <li>Food recommendations to help maintain energy levels and long-term sugar control.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.HEALTH_GUIDES,
  },
  {
    id: "meal-plan",
    image: "/images/store/meal-plan-2.webp",
    name: "Meal Plan",
    price: 1200,
    metaDescription: "A personalised eating plan built around your questionnaire answers by a registered dietitian.",
    description: (
      <React.Fragment>
        <h3>What is this plan?</h3>
        <p>
          This is a plan where you start with a questionnaire, and from there the dietitian develops
          a personalised eating plan based on the information provided. The more information
          you give us the better 🍋🍋
        </p>
        <h3>Who is it for?</h3>
        <p>
          Anyone who wishes to receive an online plan from a Registered Dietitian, but without seeing her for a consultation.
          <br />
          <i>This plan option can not be used for inidividuals with medical conditions who will require specialised diets, or individuals who require sport nutrition plans</i>
        </p>
        <h3>How does it work?</h3>
        <ul>
          <li>After purchasing, you will be redirected to our meal plan questionnaire. Once you fill out this form, Ash will create your plan within 1 week.</li>
          <li>Should you require any further assistance, you can check in with one of our dietitians for an appointment either online or in-person.</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.MEAL_PLANS,
  },
  {
    id: "bi-monthly-menu-and-shopping-list",
    image: "/images/store/shopping-list-subscription1.webp",
    name: "Bi-monthly Menu & Shopping List Subscription",
    price: 139,
    billingFrequency: 5, //PayFast bi-annual
    billingMultiplier: 1,
    options: [
      {
        id: "bi-annual",
        price: 139,
        billingFrequency: 5, //PayFast bi-annual
        billingMultiplier: 6,
        billingFrequencyText: "Charged every 6 months",
        discountText: "30% discount",
      },
      {
        id: "quarterly",
        price: 160,
        billingFrequency: 4,  //PayFast quarterly
        billingMultiplier: 3,
        billingFrequencyText: "Charged every 3 months",
        discountText: "20% discount",
      },
      {
        id: "monthly",
        price: 199,
        billingMultiplier: 1,
        billingFrequency: 3,  //PayFast monthly
        billingFrequencyText: "Charged monthly",
      },
    ],
    isSub: true,
    metaDescription: "A twice-monthly family menu and shopping list subscription created by a registered dietitian.",
    description: (
      <React.Fragment>
        <h3>Discover the Joy of Healthy Eating</h3>
        <p>
          With a little planning and some simple, delicious recipes, you can enjoy a week of healthy meals that save you time and
          money. Say goodbye to aimlessly wandering the grocery store, buying random items that go to waste, and enduring the same
          boring meals on repeat. Let me take the guesswork out of meal planning for you!
        </p>
        <h3>How I Can Help You</h3>
        <p>
          As a registered dietitian, I’ve created two fresh weekly menus a month to make healthy eating effortless and enjoyable. Each plan includes:
        </p>
        <ul>
          <li>An extensive shopping list tailored to your chosen store.</li>
          <li>A family-friendly menu packed with variety.</li>
          <li>A fun dessert recipe to enjoy every week.</li>
          <li>Quick, easy and nutritious recipes to choose from.</li>
        </ul>
        <h3>How the Subscription Works</h3>
        <ul>
          <li>You’ll receive your new menu and shopping list via email twice a month (on the first and third Friday).</li>
          <li>The subscription starts at just R139.00 per month. Payment is handled through PayFast via credit card - you will be charged periodically starting as of today (if you sign up on the 20th, your next payment will be on the 20th again).</li>
        </ul>
        <img
          src={"/images/store/subscription-info-3.webp"}
          className={"subscription-info-img"}
        />
      </React.Fragment>
    ),
    type: STORE_FILTERS.MEAL_PLANS,
  },
  {
    id: "6-week-couch-to-5km-plan",
    image: "/images/store/couch-to-5km.webp",
    gallery: [
      "/images/store/couch-to-5km-gal-1.webp",
      "/images/store/couch-to-5km-gal-2.webp",
    ],
    name: "6-Week Couch to 5KM Plan",
    price: 250,
    metaDescription: "A 6-week structured running plan to take beginners from zero to 5km safely.",
    description: (
      <React.Fragment>
        <p>Go from zero to 5KM with confidence and support</p>
        <h3>Who is plan is perfect for?</h3>
        <p>
          Ready to start running but don’t know where to begin?
          My 6-Week Couch to 5KM Plan is the perfect starting point for absolute
          beginners. Whether you haven’t exercised in a while or want a gentle
          reintroduction to fitness, this structured, step-by-step plan will build your
          running endurance safely and effectively, no matter your current fitness
          level.
        </p>
        <h3>What is included?</h3>
        <ul>
          <li>A progressive weekly schedule alternating walking and running</li>
          <li>Guided intervals to gradually build stamina and reduce injury risk</li>
          <li>Dedicated stretching routines to improve mobility and recovery</li>
          <li>Incline walking and strength session options to boost endurance</li>
          <li>Rest days and flexible guidance so you can adapt the plan to your pace</li>
        </ul>
        <p>
          You’ll also get expert tips on stretching, pacing, and building lasting habits,
          all backed by me, a registered dietitian with a special interest in sports
          nutrition and exercise science.
        </p>
        <p>
          No gym. No pressure. 
        </p>
        <p>
          <i>
            This plan pairs well with our strength runner program – to provide you
            with extra strength and support during your runs.
          </i>
        </p>
      </React.Fragment>
    ),
    type: STORE_FILTERS.EXERCISE_PLANS,
  },
  {
    id: "20-min-home-workout",
    image: "/images/store/20-min-home-workout-1.webp",
    gallery: [
      "/images/store/20-minute-gal-1.webp",
      "/images/store/20-minute-gal-2.webp",
    ],
    name: "20 Min Home Workout",
    price: 250,
    metaDescription: "A 20-minute home workout plan for building strength and fitness with minimal equipment.",
    description: (
      <React.Fragment>
        <p>Your time-efficient path to strength and fitness</p>
        <p>
          No time for the gym? No problem. My 20-Minute Home Workout Plan is a
          simple, effective fitness program designed to help you move your body,
          build strength, and boost energy, all from the comfort of your home, with
          minimal equipment and zero stress.
        </p>
        <h3>Who is plan is perfect for?</h3>
        <ul>
          <li>Beginners getting started with fitness</li>
          <li>Busy individuals who want to be consistent with exercise, but are short on time</li>
          <li>Anyone wanting to move more and feel better at home</li>
        </ul>
        <h3>What is included?</h3>
        <ul>
          <li>A structured weekly schedule alternating lower body, upper body, abs, and cardio</li>
          <li>Minimal equipment needed: skipping rope, resistance band, dumbbells (or household alternatives)</li>
          <li>Warm-ups, modifications, and progression tips for all fitness levels</li>
          <li>Quick but powerful 20-minute workouts (with optional intensity boosters)</li>
          <li>Guided strength, core, and cardio circuits to tone, burn fat, and improve endurance</li>
        </ul>
        <p>
          Whether you’re squeezing in a morning session or adding movement to
          your evenings, this plan helps you make consistent progress without
          overthinking your workouts.
        </p>
        <p>
          Just 20 minutes a day, no gym, no hassle! 
        </p>
      </React.Fragment>
    ),
    type: STORE_FILTERS.EXERCISE_PLANS,
  },
  {
    id: "muscle-building-plan",
    image: "/images/store/muscle-building.webp",
    gallery: [
      "/images/store/muscle-building-gal-1.webp",
      "/images/store/muscle-building-gal-2.webp",
    ],
    name: "Muscle Building Plan",
    price: 250,
    metaDescription: "A 6-week progressive strength training plan for building lean muscle.",
    description: (
      <React.Fragment>
        <p>
          Designed for those ready to take their fitness to the next level, the Muscle
          Building Plan is a structured 6-week training guide focused on progressive
          overload, targeted muscle group training, and real results.
        </p>
        <p>
          Whether you're starting your strength journey or pushing for your next
          personal best, this plan offers a smart, balanced approach to muscle
          development, with expert input from a registered dietitian and exercise
          science professional.
        </p>
        <h3>Who is this plan for?</h3>
        <ul>
          <li>Individuals wanting to build lean muscle and improve body composition</li>
          <li>Gym-goers who need a structured, progressive training schedule</li>
          <li>Beginners ready to learn proper strength training technique</li>
          <li>Intermediate lifters looking to break through plateaus</li>
          <li>Anyone wanting to feel stronger, more toned, and confident in their training</li>
        </ul>
        <h3>What is included?</h3>
        <ul>
          <li>A 6-week progressive training schedule (upper/lower split)</li>
          <li>Workouts targeting glutes, hamstrings, quads, back, shoulders, biceps & triceps</li>
          <li>Rest days and cardio to support recovery and conditioning</li>
          <li>Built-in progressive overload system to increase challenge week by week</li>
          <li>Proper warm-ups, technique tips, and structured rest periods</li>
          <li>Equipment guidance (gym or home adaptations available)</li>
        </ul>
      </React.Fragment>
    ),
    type: STORE_FILTERS.EXERCISE_PLANS,
  },
  {
    id: "toning-exercise-plan",
    image: "/images/store/toning-exercise.webp",
    gallery: [
      "/images/store/toning-exercise-gal-1.webp",
      "/images/store/toning-exercise-gal-2.webp",
    ],
    name: "Toning Exercise Plan",
    price: 250,
    metaDescription: "An 8-week toning plan combining full-body strength training, core work, and cardio.",
    description: (
      <React.Fragment>
        <p>
          This 8-week Toning Exercise Plan is designed to help you build lean
          muscle, sculpt your physique, and improve overall fitness. It combines fullbody strength training, core conditioning, and cardio in a structured,
          progressive format tailored to help you feel stronger, more defined, and
          energised.
        </p>
        <p>
          Created by myself, a registered dietitian, certified in exercise science, this
          plan offers expert guidance to help you move with purpose and
          confidence.
        </p>
        <h3>Who is this plan for?</h3>
        <ul>
          <li>Women and men who want to tone and tighten</li>
          <li>Beginners and intermediates looking for structured strength training</li>
          <li>Clients who want to improve definition, especially in glutes, legs, arms, and core</li>
          <li>Those seeking a sustainable routine to support weight loss, improve posture, and boost metabolism</li>
          <li>People who prefer clear, easy-to-follow workouts they can do at home or in the gym with minimal equipment</li>
        </ul>
        <h3>What is included?</h3>
        <ul>
          <li>An 8-week progressive training schedule (split by muscle groups and goals)</li>
          <li>Targeted workouts for glutes, legs, arms, abs, and shoulders</li>
          <li>Progressive overload techniques to prevent plateaus and enhance results</li>
          <li>Cardio sessions for fat-burning and conditioning</li>
          <li>Clear warm-up instructions and structured rest breaks</li>
          <li>Options for home or gym-based equipment (resistance bands, dumbbells, machines)</li>
        </ul>
        <p>
          This plan is ideal for anyone wanting to shape and define their body while
          building long-term strength and consistency.
        </p>
      </React.Fragment>
    ),
    type: STORE_FILTERS.EXERCISE_PLANS,
  },
  {
    id: "strength-plan-for-runners",
    image: "/images/store/strength-runners.webp",
    gallery: [
      "/images/store/strength-runners-gal-1.webp",
      "/images/store/strength-runners-gal-2.webp",
    ],
    name: "Strength Plan for Runners",
    price: 250,
    metaDescription: "An 8-week strength training plan for runners, built to improve performance and prevent injury.",
    description: (
      <React.Fragment>
        <h3>Run stronger. Recover faster. Stay injury-free.</h3>
        <p>
          Runners often focus only on mileage, but real progress comes when you
          build strength too. This 8-week Strength Plan for Runners is designed to
          support running performance through targeted strength training that
          improves endurance, stability, and injury prevention.
        </p>
        <p>
          Crafted by me, a registered dietitian with expertise in exercise science, this
          plan integrates seamlessly into your run schedule without overwhelming
          your recovery.
        </p>
        <h3>Who is this plan for?</h3>
        <ul>
          <li>Runners who want to build strength to support better running performance</li>
          <li>Beginners or experienced runners aiming to prevent injury and improve posture</li>
          <li>Athletes looking to balance their training with structured strength work</li>
          <li>Anyone wanting a flexible, evidence-based strength routine that supports endurance</li>
        </ul>
        <h3>What is included?</h3>
        <ul>
          <li>An 8-week progressive training split to complement your run training</li>
          <li>Upper and lower body strength workouts focused on running-specific muscle groups</li>
          <li>Glute, hamstring, quad, core, and calf work to build power and reduce imbalances</li>
          <li>Rest and cardio recommendations to avoid overtraining</li>
          <li>Weekly progression and overload guidance to ensure results</li>
          <li>Gym-based movements with clear structure and adaptable rest times</li>
        </ul>
        <p>
          Whether you’re training for a race or just want to move more efficiently,
          this plan will help you run stronger and recover smarter.
        </p>
      </React.Fragment>
    ),
    type: STORE_FILTERS.EXERCISE_PLANS,
  },
];

export default data;

export const DISCOUNT_CODES = {
  "getmoving20": {
    value: 0.2,
    type: STORE_FILTERS.EXERCISE_PLANS,
  },
  "move10": {
    value: 0.1,
    type: STORE_FILTERS.EXERCISE_PLANS,
  },
  "sweat15": {
    value: 0.15,
    type: STORE_FILTERS.EXERCISE_PLANS,
  },
  "goalin20": {
    value: 0.2,
    type: STORE_FILTERS.EXERCISE_PLANS,
  },
  "transform25": {
    value: 0.25,
    type: STORE_FILTERS.EXERCISE_PLANS,
  },
};
